import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "title" }, "Información del evento", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_GeneralInput, {
          text: _ctx.name.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name.val) = $event)),
          value: _ctx.name.val,
          label: 'Nombre',
          "has-error": _ctx.name.enabled,
          error: _ctx.name.errors.length === 0 ? '' : _ctx.name.errors[0],
          class: "input-full"
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_DatePickerInput, {
          text: _ctx.date.val,
          "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date.val) = $event)),
          value: _ctx.date.val,
          label: 'Fecha máxima de registro',
          "has-error": _ctx.date.enabled,
          error: _ctx.date.errors.length === 0 ? '' : _ctx.date.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_GeneralInput, {
          text: _ctx.guests.val,
          "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.guests.val) = $event)),
          value: _ctx.guests.val,
          label: 'Máximo de invitados por cliente',
          "has-error": _ctx.guests.enabled,
          error: _ctx.guests.errors.length === 0 ? '' : _ctx.guests.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.createEditEvent
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}